import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import { ThemeProvider } from '@mui/material/styles';
import { Theme } from './components/MuiTheme/Theme';
import AlertTemplate from 'react-alert-template-basic';
import { PrimeReactProvider } from 'primereact/api';
import {store, persistor} from '@Redux/store';
import Routes from './Routes/Routes';
import ErrorFallBack from './ErrorFallBack';
import { ErrorBoundary } from 'react-error-boundary';
import GlobalSnackbar from '@CommonFunctionalDisplay/GlobalSnackbar';
import 'typeface-roboto';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import '@Hooks/useGlobalRequestHandler';
import './index.scss';

const options = {
    position: positions.MIDDLE,
    timeout: 5000,
    transition: transitions.SCALE,
};

render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <PrimeReactProvider>
                    <AlertProvider template={AlertTemplate} {...options}>
                        <ThemeProvider theme={Theme}>
                            <ErrorBoundary FallbackComponent={ErrorFallBack}>
                                <GlobalSnackbar />
                                <RouterProvider router={Routes} />
                            </ErrorBoundary>
                        </ThemeProvider>
                    </AlertProvider>
                </PrimeReactProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);

reportWebVitals();
